<template>
  <div class="transactions wrap">
    <div class="wrapContent">
      <!-- 条件区域 -->
      <div class="conditions">
        <div class="item">
          <div class="left">
            {{pc_lang.Transaction_Type}}
          </div>
          <div class="right">
            <p v-for="item in dealType" :key="item.words" v-text="item.words" :class="{ act : conditionsForm.trade_type === item.id }" @click="conditionsForm.trade_type = item.id"></p>
          </div>
        </div>
        <div class="item">
          <div class="left">
            {{pc_lang.transaction_currency}}
          </div>
          <div class="right">
            <p :class="{ act : conditionsForm.currency_short === '' }" @click="conditionsForm.currency_short =''">{{pc_lang.All}}</p>
            <p v-for="item in balanceList" :key="item.currency_short" v-text="item.currency_short" :class="{ act : conditionsForm.currency_short === item.currency_short }" @click="conditionsForm.currency_short = item.currency_short"></p>
          </div>
        </div>
        <div class="item">
          <div class="left">
            {{pc_lang.Status}}
          </div>
          <div class="right">
            <p v-for="item in dealStatus" :key="item.words" v-text="item.words" :class="{ act : conditionsForm.money_flow === item.id }" @click="conditionsForm.money_flow = item.id"></p>
          </div>
        </div>
        <div class="item">
          <div class="left">
            {{pc_lang.Time_period}}
          </div>
          <div class="right">
            <el-date-picker
              v-model="conditionsForm.time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="timestamp"
              :range-separator="pc_lang.to"
              :start-placeholder="pc_lang.Start_date"
              :end-placeholder="pc_lang.End_date"
              size="medium"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
        <div class="moreConditions" @click="moreConditionsBool = !moreConditionsBool">
          {{pc_lang.More_filters}} <i class="el-icon-caret-top" :class="{ down : moreConditionsBool }"></i>
        </div>
        <div class="item" v-show="moreConditionsBool">
          <div class="left">
            {{pc_lang.Amount_range}}
          </div>
          <div class="right amount">
            <el-input type="text" :placeholder="pc_lang.Enter_starting_amount" size="medium" v-model="conditionsForm.start_money"></el-input>
            <span>-</span>
            <el-input type="text" :placeholder="pc_lang.Enter_end_amount" size="medium" v-model="conditionsForm.end_money"></el-input>
          </div>
        </div>
        <div class="item" v-show="moreConditionsBool">
          <div class="left">
            {{pc_lang.Keywords}}
          </div>
          <div class="right">
            <el-input type="text" :placeholder="pc_lang.Enter_keywords" size="medium" v-model="conditionsForm.keyword"></el-input>
          </div>
        </div>
      </div>
      <!-- 表格 -->
      <BalanceRecordForm :formList="tableData" class="formItems" @handleCheck="handleCheck"/>
      <!-- 分页 -->
      <Pagination :paginationItem="paginationItem" @changePage="changeCurrentPage" ref="pagination" class="pagination"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { DatePicker, Input } from 'element-ui'
Vue.use(DatePicker).use(Input)
import { mapGetters } from 'vuex'
import BalanceRecordForm from '@/components/ui/BalanceRecordForm'
import Pagination from '@/components/ui/Pagination'
import both from '@/utils/storage'

import * as API_PAY from '@/api/pay'

export default {
  name: 'BalanceRecord',
  components:{
    BalanceRecordForm,
    Pagination,
  },
  computed: {
    /* 交易状态 */
    dealStatus() {
      return [
        {
          id: '',
          words: this.pc_lang.All
        },
        {
          id: 1,
          words: this.pc_lang.IN
        },
        {
          id: 2,
          words: this.pc_lang.OUT
        }
      ]
    },
    /* 日期快捷选项 */
    pickerOptions() {
      return {
        shortcuts: [{
          text: this.pc_lang.last_week,
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.pc_lang.last_month,
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.pc_lang.last_three_months,
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    }
  },
  data() {
    return {
      paginationItem: {
        page_size: 10,
        pageTotal: 200,
        page_number: 1,
      },
      /* 余额列表 */
      balanceList: [],
      tableData: [],
      /* 等多筛选bool */
      moreConditionsBool: 0,
      /* 筛选form */
      conditionsForm: {
        trade_type: '',
        currency_short: '',
        money_flow: '',
        time: '',
        start_time: '',
        end_time: '',
        start_money: '',
        end_money: '',
        keyword: ''
      }
    }
  },
  async mounted() {
    // this.$refs.pagination.currentPage = 5
  },
  created() {
    this.getUserBalance().then(()=> {
      this.getRecordItems()
    })
  },
  methods: {
    /* 分页currentPage */
    changeCurrentPage(i) {
      this.paginationItem.page_number = i
    },
    /* 查看详情 */
    handleCheck(item) {
      console.log(item)
    },
    /* 获取用户余额 */
    getUserBalance() {
      return new Promise((resolve, reject)=> {
        API_PAY.getUserBalance().then(res=>{
          this.balanceList = res.data
          resolve(1)
        },
        rej=>{
          console.log('rej', rej)
          reject(rej)
        })
      })
    },
    /* 获取交易记录 */
    getRecordItems() {
      let params = JSON.parse(JSON.stringify(this.conditionsForm))
      params.start_time = params.time != '' ? params.time[0] : '',
      params.end_time = params.time != '' ? this.conditionsForm.time[1] : '',
      params = { ...params, ...this.paginationItem }
      API_PAY.balanceRecord(params).then(res=> {
        this.paginationItem.pageTotal = res.data.total
        let data = res.data.data
        data.forEach(obj=> {
          try{
            /* 转换时间 */
            obj.time = both.getChinaTime(obj.time * 1000)

          }catch(err){
            console.log(err)
          }
        })
        this.tableData = data
      },rej=> console.log(rej))
    }
  },
  watch: {
    conditionsForm: {
      handler(val, oldVal){
        this.$refs.pagination.currentPage = 1
        this.paginationItem.page_number = 1
        this.getRecordItems()
      },
      deep: true
    },
    'paginationItem.page_number'(val, oldVal){
        this.paginationItem.page_number = val
        this.getRecordItems()
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapContent{
  margin: 20px auto;
  background: #fff;
  @extend .shadow;
}
.conditions{
  padding: 24px 18px;
  margin-bottom: 20px;
  .el-input__inner{
    border: 1px solid #DCDFE6;
  }
  .moreConditions{
    padding: 10px 0;
    font-size: 12px;
    cursor: pointer;
    &:hover{
      color: $blue;
    }
    i{
      &.down{
        transform: scaleY(-1)
      }
    }
  }
  .item{
    display: flex;
    padding: 20px 0;
    border-bottom: $border;
    align-items: center;
    .left{
      width: 70px;
      font-size: 12px;
      margin-right: 20px;
      position: relative;
      &:after{
        content: ':';
        position: absolute;
        height: 100%;
        right: -4px;
        top: 0;
        display: flex;
        align-items: center;
      }
    }
    .right{
      display: flex;
      align-items: center;
      p{
        font-size: 12px;
        margin-right: 22px;
        cursor: pointer;
        &.act{
          color: $blue;
        }
      }
      .amount{
        .el-input{
          width: 150px;
        }
      }
      >span{
        margin: 0 10px;
      }
    }
  }
}
.formItems{
  border-top: $border;
  margin-bottom: 20px;
}
.pagination{
  text-align: right;
}
</style>